export default "__VITE_ASSET__WHJ7l1Tw__"